"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const AbacusToNumber = ({ onScore }) => {
  const [currentTask, setCurrentTask] = useState(0)
  const [selectedNumber, setSelectedNumber] = useState(null)
  const [showResult, setShowResult] = useState(false)

  const tasks = [
    { abacusValue: 1, animals: ["🦉"], animalName: "сова" },
    { abacusValue: 2, animals: ["🐦", "🐦"], animalName: "птички" },
    { abacusValue: 3, animals: ["🐦", "🐦", "🐦"], animalName: "птички" },
    { abacusValue: 4, animals: ["🐦", "🐦", "🐦", "🐦"], animalName: "птички" },
  ]

  const current = tasks[currentTask]

  const checkAnswer = () => {
    const correct = selectedNumber === current.abacusValue
    if (correct) {
      onScore(20)
      setTimeout(() => {
        setCurrentTask((prev) => (prev + 1) % tasks.length)
        setSelectedNumber(null)
        setShowResult(false)
      }, 2000)
    }
    setShowResult(true)
  }

  return (
    <div className="lesson-card card-yellow">
      <h2 className="lesson-title" style={{ color: "#a16207" }}>
        Записываем числа 🔢
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "24px",
          marginBottom: "24px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>
            Считаем {current.animalName}
          </h3>
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #3b82f6",
            }}
          >
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "16px" }}>
              {current.animals.map((animal, index) => (
                <div key={index} style={{ fontSize: "2.5rem" }}>
                  {animal}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Абакус</h3>
          <AbacusDisplay value={current.abacusValue} />
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Запиши число</h3>
          <div
            style={{
              fontSize: "3.75rem",
              fontWeight: "bold",
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px dashed #d1d5db",
            }}
          >
            {selectedNumber || "?"}
          </div>
        </div>
      </div>

      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <p style={{ fontSize: "1.25rem", marginBottom: "16px" }}>Какое число показывает абакус?</p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          {[1, 2, 3, 4].map((num) => (
            <button
              key={num}
              onClick={() => setSelectedNumber(num)}
              style={{
                fontSize: "1.5rem",
                padding: "24px",
                borderRadius: "50%",
                border: "2px solid",
                backgroundColor: selectedNumber === num ? "#eab308" : "white",
                color: selectedNumber === num ? "white" : "#374151",
                borderColor: selectedNumber === num ? "#ca8a04" : "#e5e7eb",
                cursor: "pointer",
              }}
            >
              {num}
            </button>
          ))}
        </div>
      </div>

      {showResult && (
        <div
          style={{
            textAlign: "center",
            fontSize: "1.25rem",
            marginBottom: "16px",
            color: selectedNumber === current.abacusValue ? "#16a34a" : "#dc2626",
          }}
        >
          {selectedNumber === current.abacusValue ? "🎉 Правильно!" : "❌ Попробуй еще раз!"}
        </div>
      )}

      <div style={{ textAlign: "center" }}>
        <button
          onClick={checkAnswer}
          disabled={selectedNumber === null}
          className="nav-button primary"
          style={{ opacity: selectedNumber === null ? 0.5 : 1, backgroundColor: "#eab308" }}
        >
          Проверить! ✨
        </button>
      </div>
    </div>
  )
}

export default AbacusToNumber
